import { default as getLabelFromStorage } from "@pb/utils/labels/getLabelFromStorage";
export const getVideoLabels = () => {
    return {
        playButtonText: getLabelFromStorage('video.playButtonText'),
        pauseButtonText: getLabelFromStorage('video.pauseButtonText'),
        videoLoadingText: getLabelFromStorage('video.videoLoadingText'),
    };
};
//# sourceMappingURL=getVideoLabels.js.map